module.exports = __webpack_public_path__ + "static/media/transactions_active.7df4a4aa.svg";